var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { showToast } from "../../utils/toastUtils";
import { getStripePlans, reactivateSubscription, changeSubscriptionPlan } from "../../actions/subscriptions";
import { getAgencyName } from "../../actions/users";
import ProgressLoader from "../../components/layout/ProgressLoader";
import ConfirmModal from "../../components/modals/ConfirmModal";
var Accordion = function (_a) {
    var title = _a.title, children = _a.children;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (React.createElement("div", { className: "mb-6 max-w-2xl mx-auto" },
        React.createElement("button", { className: "w-full flex items-center justify-between px-4 py-2 bg-gray-800/80 rounded-lg text-cyan-200 font-semibold text-base shadow hover:bg-gray-700 transition", onClick: function () { return setOpen(function (v) { return !v; }); }, "aria-expanded": open },
            React.createElement("span", null, title),
            React.createElement("span", { className: "ml-2" }, open ? "▲" : "▼")),
        open && (React.createElement("div", { className: "bg-gray-900/80 rounded-b-lg px-4 py-4 text-gray-200 text-sm md:text-base border-t border-cyan-700" }, children))));
};
var SubscriptionPage = function () {
    var _a = useState([]), plans = _a[0], setPlans = _a[1];
    var _b = useState([]), frequencies = _b[0], setFrequencies = _b[1];
    var _c = useState([]), dashboards = _c[0], setDashboards = _c[1];
    var _d = useState([]), subscriptions = _d[0], setSubscriptions = _d[1];
    var _e = useState(true), subsLoading = _e[0], setSubsLoading = _e[1];
    var _f = useState(0), loaderProgress = _f[0], setLoaderProgress = _f[1];
    var searchParams = useSearchParams()[0];
    var navigate = useNavigate();
    // Estado para controle do modal de confirmação
    var _g = useState(false), modalOpen = _g[0], setModalOpen = _g[1];
    var _h = useState(function () { return function () { }; }), pendingAction = _h[0], setPendingAction = _h[1];
    var _j = useState(""), modalTitle = _j[0], setModalTitle = _j[1];
    var _k = useState(""), modalDescription = _k[0], setModalDescription = _k[1];
    var _l = useState(false), modalLoading = _l[0], setModalLoading = _l[1];
    // Estado para controle do trial
    var _m = useState(false), trialEnded = _m[0], setTrialEnded = _m[1];
    // Carrega tudo de uma vez só
    var refreshAll = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getStripePlans()];
                case 2:
                    response = _a.sent();
                    setPlans(response.plans.sort(function (a, b) { return a.price - b.price; }));
                    setFrequencies(response.frequencies.sort(function (a, b) { return a.price - b.price; }));
                    setDashboards(response.dashboards.sort(function (a, b) { return a.price - b.price; }));
                    setSubscriptions(response.active_subscriptions || []);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showToast("error", "Erro ao carregar dados de assinatura.");
                    return [3 /*break*/, 5];
                case 4:
                    setSubsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        // Toast de sucesso/erro na assinatura
        var success = searchParams.get("success");
        if (success === "true") {
            showToast("success", "Assinatura realizada com sucesso!");
        }
        else if (success === "false") {
            showToast("error", "Ocorreu um erro ao realizar a assinatura.");
        }
        refreshAll();
    }, [searchParams]);
    useEffect(function () {
        if (subsLoading) {
            setLoaderProgress(0);
            var interval_1 = setInterval(function () {
                setLoaderProgress(function (prev) {
                    if (prev >= 100) {
                        clearInterval(interval_1);
                        return 100;
                    }
                    return prev + 5;
                });
            }, 250);
            return function () { return clearInterval(interval_1); };
        }
        else {
            setLoaderProgress(100);
        }
    }, [subsLoading]);
    // Verificação do trial e plano ativo
    useEffect(function () {
        function checkTrialStatus() {
            return __awaiter(this, void 0, void 0, function () {
                var agencyData, has_active_plan, created_at, creationDate, today, diffDays, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, getAgencyName()];
                        case 1:
                            agencyData = _a.sent();
                            has_active_plan = agencyData.has_active_plan, created_at = agencyData.created_at;
                            if (has_active_plan) {
                                setTrialEnded(false);
                                return [2 /*return*/];
                            }
                            if (created_at) {
                                creationDate = new Date(created_at);
                                today = new Date();
                                diffDays = Math.floor((today.getTime() - creationDate.getTime()) / (1000 * 3600 * 24));
                                if (diffDays > 14) {
                                    setTrialEnded(true);
                                }
                                else {
                                    setTrialEnded(false);
                                }
                            }
                            else {
                                setTrialEnded(true);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            setTrialEnded(false);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        checkTrialStatus();
    }, []);
    if (subsLoading) {
        return React.createElement(ProgressLoader, { progress: loaderProgress });
    }
    var formatDateBR = function (dateStr) {
        var _a = dateStr.split("-"), year = _a[0], month = _a[1], day = _a[2];
        return "".concat(day, "/").concat(month, "/").concat(year);
    };
    var changeSubscriptionPlanHandler = function (subscriptionId, newPriceId, newPlanName) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changeSubscriptionPlan(subscriptionId, newPriceId, newPlanName)];
                case 1:
                    _a.sent();
                    showToast("success", "Plano alterado com sucesso!");
                    refreshAll();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    showToast("error", "Erro ao alterar o plano.");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubscribe = function (planId, planName, planPrice, planDescription) {
        navigate("/checkout?plan_id=".concat(planId, "&plan_name=").concat(encodeURIComponent(planName), "&plan_price=").concat(encodeURIComponent(planPrice), "&plan_description=").concat(encodeURIComponent(planDescription)));
    };
    var handleCancelSubscription = function (subscriptionId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setModalTitle("Cancelar Assinatura");
            setModalDescription("Tem certeza que deseja cancelar sua assinatura? Essa ação não pode ser desfeita.");
            setPendingAction(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    window.open("https://wa.me/5562983321754?text=Ol%C3%A1%2C%20desejo%20cancelar%20minha%20assinatura%20do%20vision%20cockpit.", "_blank");
                    return [2 /*return*/];
                });
            }); }; });
            setModalOpen(true);
            return [2 /*return*/];
        });
    }); };
    var handleReactivateSubscription = function (subscriptionId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setModalTitle("Reativar Assinatura");
            setModalDescription("Tem certeza que deseja reativar sua assinatura?");
            setPendingAction(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
                var error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            setModalLoading(true);
                            return [4 /*yield*/, reactivateSubscription(subscriptionId)];
                        case 1:
                            _a.sent();
                            showToast("success", "Assinatura reativada com sucesso!");
                            refreshAll();
                            return [3 /*break*/, 4];
                        case 2:
                            error_3 = _a.sent();
                            showToast("error", "Erro ao reativar assinatura.");
                            return [3 /*break*/, 4];
                        case 3:
                            setModalLoading(false);
                            setModalOpen(false);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }; });
            setModalOpen(true);
            return [2 /*return*/];
        });
    }); };
    var hasActiveSubscription = subscriptions.some(function (sub) { return sub.plan_type === "main" && sub.status === "active"; });
    // Adicione o plano Enterprise manualmente após receber os planos da API
    var enterprisePlan = {
        id: "enterprise",
        name: "Enterprise",
        description: (React.createElement(React.Fragment, null,
            "Para opera\u00E7\u00F5es avan\u00E7adas e volumes elevados de clientes.",
            React.createElement("br", null),
            "O VisionCockpit Enterprise \u00E9 um plano personalizado, criado para gestores e ag\u00EAncias com grandes volumes de contas, necessidades espec\u00EDficas de monitoramento e maior demanda de infraestrutura.",
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("span", null, "\u2714\uFE0F Volume elevado de clientes"),
            " \u00A0",
            React.createElement("span", null, "\u2714\uFE0F Configura\u00E7\u00E3o sob medida"),
            React.createElement("br", null),
            React.createElement("span", null, "\u2714\uFE0F Frequ\u00EAncia de atualiza\u00E7\u00E3o personalizada"),
            " \u00A0",
            React.createElement("span", null, "\u2714\uFE0F Suporte direto com o time"),
            React.createElement("br", null),
            React.createElement("br", null),
            "\uD83D\uDC49 Fale com a gente para montar seu plano ideal.")),
        interval: "",
        price: null,
    };
    var allPlans = __spreadArray(__spreadArray([], plans, true), [enterprisePlan], false);
    return (React.createElement("div", { className: "min-h-[calc(100vh-112px)] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center py-2 px-1 md:py-12 md:px-2" },
        React.createElement("div", { className: "w-full max-w-5xl bg-gradient-to-br from-gray-800/90 via-gray-900/80 to-gray-800/90 rounded-3xl shadow-2xl p-3 md:p-10 flex flex-col gap-0 md:gap-12 border border-cyan-700/30" },
            trialEnded && (React.createElement("div", { className: "w-full flex justify-center mb-8" },
                React.createElement("div", { className: "bg-gradient-to-br from-blue-900 via-indigo-900 to-gray-900 border-2 border-blue-700 rounded-lg p-2 md:p-6 shadow-lg text-center text-blue-100 font-semibold text-sm md:text-lg max-w-xl flex flex-col items-center gap-2 md:gap-3" },
                    React.createElement("span", { className: "text-base md:text-2xl mb-2" }, "\u23F0 Seu per\u00EDodo de teste chegou ao fim"),
                    React.createElement("span", null,
                        "Durante o teste, voc\u00EA usou o VisionCockpit para ",
                        React.createElement("b", null, "monitorar seus clientes em um \u00FAnico lugar"),
                        " e receber alertas quando algo sai do normal."),
                    React.createElement("span", null, "Para continuar acompanhando suas contas com tranquilidade, escolha um plano abaixo \uD83D\uDC47"),
                    React.createElement("div", { className: "flex flex-col items-center mt-2 text-sm text-blue-200 gap-1" },
                        React.createElement("span", null, "\u2714\uFE0F Seus clientes e configura\u00E7\u00F5es continuam salvos"),
                        React.createElement("span", null, "\u2714\uFE0F Ative em menos de 1 minuto"))))),
            React.createElement("section", { className: "w-full mb-10" },
                React.createElement("h2", { className: "text-2xl font-bold mb-6 text-cyan-300 text-center" }, "Assinaturas"),
                React.createElement("div", { className: "flex flex-wrap justify-center gap-3 md:gap-8" }, allPlans.map(function (plan) {
                    // Enterprise: botão WhatsApp e texto extra
                    if (plan.id === "enterprise") {
                        return (React.createElement("div", { key: plan.id, className: "w-[100%] md:w-[800px] rounded-2xl shadow-xl px-6 py-2 flex flex-col items-center border-4 border-purple-700 bg-gradient-to-br from-indigo-900 via-purple-900 to-gray-900 hover:scale-105 transition-transform duration-300" },
                            React.createElement("h3", { className: "text-xl font-bold mb-2 text-yellow-300" }, plan.name),
                            React.createElement("div", { className: "text-gray-200 text-center mb-1 text-sm" }, plan.description),
                            React.createElement("a", { href: "https://wa.me/5562983321754?text=Ol\u00E1,%20gostaria%20de%20montar%20um%20plano%20Enterprise%20no%20VisionCockpit.", target: "_blank", rel: "noopener noreferrer", className: "mt-auto px-6 py-2 rounded-lg bg-gradient-to-r from-yellow-400 via-orange-400 to-purple-600 text-gray-900 font-bold shadow-lg transition-all hover:from-yellow-500 hover:to-purple-700 text-center" }, "Falar com a equipe no WhatsApp"),
                            React.createElement("div", { className: "mt-3 text-xs text-gray-400 text-center" }, "Planos Enterprise s\u00E3o avaliados individualmente de acordo com volume de clientes, contas de an\u00FAncio e frequ\u00EAncia de atualiza\u00E7\u00E3o.")));
                    }
                    // Demais planos (não Enterprise)
                    var activeSub = subscriptions.find(function (sub) { return sub.plan_id === plan.id && sub.status === "active"; });
                    var isActive = !!activeSub || (!hasActiveSubscription && plan.id === "free");
                    var formattedPrice = plan.price !== null && plan.price !== undefined
                        ? "R$ ".concat(plan.price.toFixed(2).replace('.', ','))
                        : "";
                    // Exibir "mensal" se for month, senão mostrar o valor original
                    var intervalLabel = plan.interval === "month" ? "Mensal" : plan.interval;
                    // Evidenciar o plano "Agência"
                    var isAgencia = plan.name.toLowerCase() === "agência";
                    // Lógica dos botões
                    var buttonLabel = "Assinar";
                    var buttonColor = "from-cyan-500 to-blue-500";
                    var buttonAction = function () { var _a; return handleSubscribe(plan.id, plan.name, (_a = plan.price) === null || _a === void 0 ? void 0 : _a.toFixed(2).replace('.', ','), plan.description); };
                    if (trialEnded && !hasActiveSubscription) {
                        buttonLabel = "Voltar a acompanhar meus clientes";
                    }
                    if (hasActiveSubscription && plan.id !== "free") {
                        var currentPlan_1 = subscriptions.find(function (sub) { return sub.plan_type === "main" && sub.status === "active"; });
                        var currentPrice = currentPlan_1 ? parseFloat(currentPlan_1.price) : 0;
                        if (plan.price > currentPrice) {
                            buttonLabel = "Upgrade";
                            buttonColor = "from-green-500 to-blue-500";
                            buttonAction = function () { return changeSubscriptionPlanHandler(currentPlan_1.id, plan.id, plan.name); };
                        }
                        else if (plan.price < currentPrice) {
                            buttonLabel = "Downgrade";
                            buttonColor = "from-yellow-500 to-orange-500";
                            buttonAction = function () { return changeSubscriptionPlanHandler(currentPlan_1.id, plan.id, plan.name); };
                        }
                        else if (plan.price === currentPrice) {
                            // Plano atual
                            if (activeSub === null || activeSub === void 0 ? void 0 : activeSub.cancel_at_period_end) {
                                buttonLabel = "Reativar Plano";
                                buttonColor = "from-green-500 to-blue-500";
                                buttonAction = function () { return handleReactivateSubscription(activeSub.id); };
                            }
                            else {
                                buttonLabel = "Cancelar Plano";
                                buttonColor = "from-red-500 to-pink-500";
                                buttonAction = function () { return handleCancelSubscription(activeSub.id); };
                            }
                        }
                    }
                    return (React.createElement("div", { key: plan.id, className: "w-[100%] md:w-[250px] rounded-2xl shadow-xl px-6 py-2 md:py-8 flex flex-col items-center border-4\n                    ".concat(isActive
                            ? "border-green-500 bg-gradient-to-br from-green-700 via-green-900 to-green-700"
                            : "border-cyan-700 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900", "\n                    ").concat(isAgencia ? "ring-4 ring-yellow-400 ring-offset-2" : "", "\n                    hover:scale-105 transition-transform duration-300") },
                        React.createElement("h3", { className: "text-xl font-bold mb-2 text-cyan-200 ".concat(isAgencia ? "text-yellow-300" : "") },
                            plan.name,
                            isAgencia && (React.createElement("span", { className: "ml-2 px-2 py-0.5 rounded bg-yellow-400 text-gray-900 text-xs font-bold align-middle animate-pulse-slow" }, "Mais escolhido"))),
                        React.createElement("span", { className: "text-3xl font-extrabold mb-2 text-white" }, formattedPrice),
                        React.createElement("span", { className: "text-sm text-gray-400 mb-2" },
                            "Cobran\u00E7a: ",
                            intervalLabel),
                        React.createElement("p", { className: "text-gray-300 text-center mb-4 ".concat(plan.id === "free" ? "flex flex-col justify-center h-24" : "") }, plan.description),
                        isActive && (activeSub === null || activeSub === void 0 ? void 0 : activeSub.cancel_at_period_end) && (activeSub === null || activeSub === void 0 ? void 0 : activeSub.renewal_date) && (React.createElement("div", { className: "mb-2 text-yellow-300 text-sm font-semibold text-center" },
                            "Seu plano permanece ativo at\u00E9 ",
                            formatDateBR(activeSub.renewal_date))),
                        plan.id !== "free" && (React.createElement("button", { className: "text-sm md:text-base mt-auto mb-1 md:mb-0 px-2 py-1 md:py-2 rounded-lg bg-gradient-to-r ".concat(buttonColor, " text-white font-bold shadow-lg transition-all"), onClick: buttonAction, disabled: isActive && !["Cancelar Plano", "Reativar Plano"].includes(buttonLabel) && plan.price === parseFloat(activeSub === null || activeSub === void 0 ? void 0 : activeSub.price) }, buttonLabel))));
                }))),
            frequencies.length > 0 && (React.createElement("section", { className: "w-full mb-10" },
                React.createElement("h2", { className: "text-2xl font-bold mt-6 mb-6 text-cyan-300 text-center" }, "Frequ\u00EAncias de Atualiza\u00E7\u00F5es"),
                React.createElement(Accordion, { title: "O que \u00E9 a frequ\u00EAncia de atualiza\u00E7\u00E3o dos dados?" },
                    React.createElement("span", { className: "block font-semibold text-cyan-300 mb-1" }, "\uD83D\uDD01 Frequ\u00EAncia de Atualiza\u00E7\u00E3o dos Dados"),
                    React.createElement("span", null,
                        "Por padr\u00E3o, todas as contas no VisionCockpit s\u00E3o atualizadas ",
                        React.createElement("b", null, "a cada 1 hora"),
                        ".",
                        React.createElement("br", null),
                        "Essa frequ\u00EAncia \u00E9 ideal para a maioria dos gestores de tr\u00E1fego, garantindo:",
                        React.createElement("ul", { className: "list-disc list-inside ml-4 my-2" },
                            React.createElement("li", null, "Monitoramento cont\u00EDnuo"),
                            React.createElement("li", null, "Alertas relevantes no WhatsApp"),
                            React.createElement("li", null, "Uso eficiente da infraestrutura")),
                        "Caso voc\u00EA precise de atualiza\u00E7\u00F5es mais r\u00E1pidas, \u00E9 poss\u00EDvel contratar pacotes adicionais de frequ\u00EAncia, com intervalos menores.",
                        React.createElement("br", null),
                        React.createElement("span", { className: "block mt-2" },
                            "\u2714\uFE0F ",
                            React.createElement("b", null, "Padr\u00E3o:"),
                            " atualiza\u00E7\u00E3o a cada 1 hora (inclusa em todos os planos)",
                            React.createElement("br", null),
                            "\u26A1 ",
                            React.createElement("b", null, "Avan\u00E7ado:"),
                            " atualiza\u00E7\u00F5es mais r\u00E1pidas mediante pacote adicional"),
                        React.createElement("span", { className: "block mt-2 text-yellow-300" },
                            React.createElement("b", null, "\uD83D\uDCCC Importante:"),
                            " Frequ\u00EAncias menores exigem maior consumo de processamento e chamadas \u00E0s APIs das plataformas, por isso s\u00E3o oferecidas como adicionais."))),
                React.createElement("div", { className: "flex flex-wrap justify-center gap-3 md:gap-8" }, frequencies.map(function (frequency) {
                    var activeSub = subscriptions.find(function (sub) { return sub.plan_id === frequency.id && sub.status === "active"; });
                    var isFrequencyActive = !!activeSub;
                    var formattedFrequencyPrice = "R$ ".concat(frequency.price.toFixed(2).replace('.', ','));
                    // Lógica dos botões para frequência
                    var buttonLabel = "Acelerar Atualizações";
                    var buttonColor = "from-green-500 to-blue-500";
                    var buttonAction = function () { return handleSubscribe(frequency.id, frequency.name, frequency.price.toFixed(2).replace('.', ','), frequency.description); };
                    // Descobre o pacote de frequência ativo
                    var currentFrequencySub = subscriptions.find(function (sub) { return sub.plan_type === "frequency" && sub.status === "active"; });
                    var currentFrequencyPrice = currentFrequencySub ? parseFloat(currentFrequencySub.price) : 0;
                    if (currentFrequencySub) {
                        if (frequency.price > currentFrequencyPrice) {
                            buttonLabel = "Upgrade";
                            buttonColor = "from-green-500 to-blue-500";
                            buttonAction = function () { return changeSubscriptionPlanHandler(currentFrequencySub.id, frequency.id, frequency.name); };
                        }
                        else if (frequency.price < currentFrequencyPrice) {
                            buttonLabel = "Downgrade";
                            buttonColor = "from-yellow-500 to-orange-500";
                            buttonAction = function () { return changeSubscriptionPlanHandler(currentFrequencySub.id, frequency.id, frequency.name); };
                        }
                        else if (frequency.price === currentFrequencyPrice) {
                            // Frequência atual
                            if (activeSub === null || activeSub === void 0 ? void 0 : activeSub.cancel_at_period_end) {
                                buttonLabel = "Reativar Pacote";
                                buttonColor = "from-green-500 to-blue-500";
                                buttonAction = function () { return handleReactivateSubscription(activeSub.id); };
                            }
                            else {
                                buttonLabel = "Cancelar Pacote";
                                buttonColor = "from-red-500 to-pink-500";
                                buttonAction = function () { return handleCancelSubscription(activeSub.id); };
                            }
                        }
                    }
                    return (React.createElement("div", { key: frequency.id, className: "w-[100%] md:w-full max-w-sm rounded-2xl shadow-xl px-6 py-3 md:py-8 flex flex-col items-center border-2 ".concat(isFrequencyActive
                            ? "border-green-500 bg-gradient-to-br from-green-900 via-green-800 to-green-700"
                            : "border-cyan-700 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900", " hover:scale-105 transition-transform duration-300") },
                        React.createElement("h3", { className: "text-xl font-bold mb-2 text-cyan-200" }, frequency.name),
                        React.createElement("span", { className: "text-3xl font-extrabold mb-2 text-white" }, formattedFrequencyPrice),
                        React.createElement("span", { className: "text-sm text-gray-400 mb-2" },
                            "Cobran\u00E7a: ",
                            frequency.interval),
                        React.createElement("p", { className: "text-gray-300 text-center mb-4" }, frequency.description),
                        React.createElement("button", { className: "mt-auto px-6 py-1 md:py-2 rounded-lg bg-gradient-to-r ".concat(buttonColor, " text-white font-bold shadow-lg transition-all"), onClick: buttonAction, disabled: isFrequencyActive && !["Cancelar Pacote", "Reativar Pacote"].includes(buttonLabel) && frequency.price === parseFloat(activeSub === null || activeSub === void 0 ? void 0 : activeSub.price) }, buttonLabel)));
                })))),
            dashboards && dashboards.length > 0 && (React.createElement("section", { className: "w-full mb-10" },
                React.createElement("h2", { className: "text-2xl font-bold mb-6 text-cyan-300 text-center" }, "Adicionais de Dashboards"),
                React.createElement("div", { className: "flex flex-wrap justify-center gap-3 md:gap-8" }, dashboards.map(function (dashboard) {
                    var activeSub = subscriptions.find(function (sub) { return sub.plan_id === dashboard.id && sub.status === "active"; });
                    var isDashboardActive = !!activeSub;
                    var formattedDashboardPrice = "R$ ".concat(dashboard.price.toFixed(2).replace('.', ','));
                    return (React.createElement("div", { key: dashboard.id, className: "w-full max-w-xs rounded-2xl shadow-xl px-6 py-8 flex flex-col items-center border-2 ".concat(isDashboardActive
                            ? "border-green-500 bg-gradient-to-br from-green-900 via-green-800 to-green-700"
                            : "border-cyan-700 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900", " hover:scale-105 transition-transform duration-300") },
                        React.createElement("h3", { className: "text-xl font-bold mb-2 text-cyan-200" }, dashboard.name),
                        React.createElement("span", { className: "text-3xl font-extrabold mb-2 text-white" }, formattedDashboardPrice),
                        React.createElement("span", { className: "text-sm text-gray-400 mb-2" },
                            "Cobran\u00E7a: ",
                            dashboard.interval),
                        React.createElement("p", { className: "text-gray-300 text-center mb-4" }, dashboard.description),
                        isDashboardActive ? (React.createElement("button", { className: "mt-auto px-6 py-2 rounded-lg bg-gradient-to-r from-red-500 to-pink-500 text-white font-bold shadow-lg hover:from-red-600 hover:to-pink-600 transition-all", onClick: function () { return handleCancelSubscription(activeSub === null || activeSub === void 0 ? void 0 : activeSub.id); }, disabled: !(activeSub === null || activeSub === void 0 ? void 0 : activeSub.id) }, "Cancelar Pacote")) : (React.createElement("button", { className: "mt-auto px-6 py-2 rounded-lg bg-gradient-to-r from-green-500 to-blue-500 text-white font-bold shadow-lg hover:from-green-600 hover:to-blue-600 transition-all", onClick: function () { return handleSubscribe(dashboard.id, dashboard.name, dashboard.price.toFixed(2).replace('.', ','), dashboard.description); } }, "Adicionar"))));
                }))))),
        React.createElement(ConfirmModal, { open: modalOpen, title: modalTitle, description: modalDescription, onConfirm: pendingAction, onCancel: function () { return setModalOpen(false); }, loading: modalLoading })));
};
export default SubscriptionPage;
